import { StyleParamType, wixColorParam, wixFontParam } from '@wix/tpa-settings';
import {
  DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  DESK_DEFAULT_SPACE_GALLERY,
  DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW,
  DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW_HASHTAG,
  DESK_DEFAULT_COUNT_ROWS,
  DESK_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  SLIDER_ARROW_SETTINGS,
} from '../constants/proGalleryConstants';
import { getDefaultLang } from '../actions/more/langHelperFunctions';
import {
  PROFILE_LAYOUT_POSITIN,
  FEED_LAYOUT_POSITIN,
  HASHTAG_LAYOUT_POSITIN,
  DEFAULT_AVATAR_SIZE_DESKTOP,
  DEFAULT_AVATAR_PADDING_TOP_BOTTOM,
  DEFAULT_AVATAR_PADDING_LEFT_RIGHT,
} from '../constants';
import {
  LAYOUTS,
  PROFILE_PICTURE_RADIUS,
  SORT_HASHTAG_OPTIONS,
  ALIGNMENT,
  RATIO,
  DISPLAY_ON_HOVER,
  COLLAGE_POST_SIZE,
  HASHTAG_TITLE_OPTIONS,
  CLICKING_ON_AVATAR_OPTIONS,
  OVERLAY_EFFECTS,
  IMAGE_HOVER_EFFECTS,
} from '../constants/settingsConstants';

const instagramStyleParams = {
  /// //////////////////////
  // BOOLEANS
  /// //////////////////////
  isNewStyles: {
    type: StyleParamType.Boolean,
    key: 'isNewStyles',
    getDefaultValue: () => false,
  },
  isDisplayProfileInfo: {
    type: StyleParamType.Boolean,
    key: 'isDisplayProfileInfo',
    getDefaultValue: () => true,
  },
  isDisplayProfilePicture: {
    type: StyleParamType.Boolean,
    key: 'isDisplayProfilePicture',
    getDefaultValue: () => true,
  },
  isDisplayTitle: {
    type: StyleParamType.Boolean,
    key: 'isDisplayTitle',
    getDefaultValue: () => true,
  },
  isDisplayPostsCount: {
    type: StyleParamType.Boolean,
    key: 'isDisplayPostsCount',
    getDefaultValue: () => true,
  },
  isDisplayFollowersCount: {
    type: StyleParamType.Boolean,
    key: 'isDisplayFollowersCount',
    getDefaultValue: () => true,
  },
  isDisplayFollowingCount: {
    type: StyleParamType.Boolean,
    key: 'isDisplayFollowingCount',
    getDefaultValue: () => true,
  },
  isDisplayProfileBio: {
    type: StyleParamType.Boolean,
    key: 'isDisplayProfileBio',
    getDefaultValue: () => true,
  },
  isDisplayFollowBtn: {
    type: StyleParamType.Boolean,
    key: 'isDisplayFollowBtn',
    getDefaultValue: () => true,
  },
  isDisplayImagesFeed: {
    type: StyleParamType.Boolean,
    key: 'isDisplayImagesFeed',
    getDefaultValue: () => true,
  },
  isDisplayHashtagsFeed: {
    type: StyleParamType.Boolean,
    key: 'isDisplayHashtagsFeed',
    getDefaultValue: () => true,
  },
  isHoverPost: {
    type: StyleParamType.Boolean,
    key: 'isHoverPost',
    getDefaultValue: () => true,
  },
  isShowMoreBtn: {
    type: StyleParamType.Boolean,
    key: 'isShowMoreBtn',
    getDefaultValue: () => true,
  },
  isShowMoreBtnCollage: {
    type: StyleParamType.Boolean,
    key: 'isShowMoreBtnCollage',
    getDefaultValue: () => true,
  },
  isShowMoreBtnCollageHashtag: {
    type: StyleParamType.Boolean,
    key: 'isShowMoreBtnCollageHashtag',
    getDefaultValue: () => true,
  },
  isShowMoreBtnHashtag: {
    type: StyleParamType.Boolean,
    key: 'isShowMoreBtnHashtag',
    getDefaultValue: () => true,
  },
  isSlideAutomatically: {
    type: StyleParamType.Boolean,
    key: 'isSlideAutomatically',
    getDefaultValue: () => false,
  },
  isSlideAutomaticallyHashtag: {
    type: StyleParamType.Boolean,
    key: 'isSlideAutomaticallyHashtag',
    getDefaultValue: () => false,
  },
  isLoopImages: {
    type: StyleParamType.Boolean,
    key: 'isLoopImages',
    getDefaultValue: () => false,
  },
  isLoopImagesHashtag: {
    type: StyleParamType.Boolean,
    key: 'isLoopImagesHashtag',
    getDefaultValue: () => false,
  },
  /// //////////////////////
  // NUMBERS
  /// //////////////////////
  ratio: {
    type: StyleParamType.Number,
    key: 'ratio',
    getDefaultValue: () => RATIO.OPTION3,
  },
  langPicker: {
    type: StyleParamType.Number,
    key: 'langPicker',
    getDefaultValue: () => getDefaultLang(),
  },
  clickingOnProfilePicture: {
    type: StyleParamType.Number,
    key: 'clickingOnProfilePicture',
    getDefaultValue: () => CLICKING_ON_AVATAR_OPTIONS.NOTHING_APPENED,
  },
  hashtagTitle: {
    type: StyleParamType.Number,
    key: 'hashtagTitle',
    getDefaultValue: () => HASHTAG_TITLE_OPTIONS.HASHTAGS,
  },
  clickingOnItem: {
    type: StyleParamType.Number,
    key: 'clickingOnItem',
    getDefaultValue: () => 1,
  },
  sortHashtagsFeed: {
    type: StyleParamType.Number,
    key: 'sortHashtagsFeed',
    getDefaultValue: () => SORT_HASHTAG_OPTIONS.MOST_VIEWED,
  },
  headerLayout: {
    type: StyleParamType.Number,
    key: 'headerLayout',
    getDefaultValue: () => 0,
  },
  hashtagLayout: {
    type: StyleParamType.Number,
    key: 'hashtagLayout',
    getDefaultValue: () => ALIGNMENT.CENTER,
  },
  profilePictureRadius: {
    type: StyleParamType.Number,
    key: 'profilePictureRadius',
    getDefaultValue: () => PROFILE_PICTURE_RADIUS.CIRCLE,
  },
  direction: {
    type: StyleParamType.Number,
    key: 'direction',
    getDefaultValue: () => 0,
  },
  layoutType: {
    type: StyleParamType.Number,
    key: 'layoutType',
    getDefaultValue: () => LAYOUTS.GRID,
  },
  galleryLayoutHashtag: {
    type: StyleParamType.Number,
    key: 'galleryLayoutHashtag',
    getDefaultValue: () => LAYOUTS.SLIDER,
  },
  numberOfRowsGrid: {
    type: StyleParamType.Number,
    key: 'numberOfRowsGrid',
    getDefaultValue: () => DESK_DEFAULT_COUNT_ROWS,
  },
  numberOfRowsGridHashtag: {
    type: StyleParamType.Number,
    key: 'numberOfRowsGridHashtag',
    getDefaultValue: () => DESK_DEFAULT_COUNT_ROWS,
  },
  cornerRadiusFeed: {
    type: StyleParamType.Number,
    key: 'cornerRadiusFeed',
    getDefaultValue: () => 0,
  },
  cornerRadiusHashtag: {
    type: StyleParamType.Number,
    key: 'cornerRadiusHashtag',
    getDefaultValue: () => 0,
  },
  numberOfColumnsGrid: {
    type: StyleParamType.Number,
    key: 'numberOfColumnsGrid',
    getDefaultValue: () => DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW,
  },
  numberOfColumnsGridHashtag: {
    type: StyleParamType.Number,
    key: 'numberOfColumnsGridHashtag',
    getDefaultValue: () => DESK_GRID_DEFAULT_COUNT_ITEM_IN_ROW_HASHTAG,
  },
  spacingGrid: {
    type: StyleParamType.Number,
    key: 'spacingGrid',
    getDefaultValue: () => DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  gallerySpacingGrid: {
    type: StyleParamType.Number,
    key: 'gallerySpacingGrid',
    getDefaultValue: () => DESK_DEFAULT_SPACE_GALLERY,
  },
  gallerySpacingGridHashtag: {
    type: StyleParamType.Number,
    key: 'gallerySpacingGridHashtag',
    getDefaultValue: () => DESK_DEFAULT_SPACE_GALLERY,
  },
  gallerySpacingCollage: {
    type: StyleParamType.Number,
    key: 'gallerySpacingCollage',
    getDefaultValue: () => DESK_DEFAULT_SPACE_GALLERY,
  },
  gallerySpacingCollageHashtag: {
    type: StyleParamType.Number,
    key: 'gallerySpacingCollageHashtag',
    getDefaultValue: () => DESK_DEFAULT_SPACE_GALLERY,
  },
  gallerySpacingSlider: {
    type: StyleParamType.Number,
    key: 'gallerySpacingSlider',
    getDefaultValue: () => DESK_DEFAULT_SPACE_GALLERY,
  },
  gallerySpacingSliderHashtag: {
    type: StyleParamType.Number,
    key: 'gallerySpacingSliderHashtag',
    getDefaultValue: () => DESK_DEFAULT_SPACE_GALLERY,
  },
  spacingCollage: {
    type: StyleParamType.Number,
    key: 'spacingCollage',
    getDefaultValue: () => DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  spacingItemsCollageHashtag: {
    type: StyleParamType.Number,
    key: 'spacingItemsCollageHashtag',
    getDefaultValue: () => DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  rowsLoadMoreGrid: {
    type: StyleParamType.Number,
    key: 'rowsLoadMoreGrid',
    getDefaultValue: () => DESK_DEFAULT_COUNT_ROWS,
  },
  rowsLoadMoreCollage: {
    type: StyleParamType.Number,
    key: 'rowsLoadMoreCollage',
    getDefaultValue: () => 1,
  },
  rowsLoadMoreCollageHashtag: {
    type: StyleParamType.Number,
    key: 'rowsLoadMoreCollageHashtag',
    getDefaultValue: () => 1,
  },
  spacingItemsGridHashtag: {
    type: StyleParamType.Number,
    key: 'spacingItemsGridHashtag',
    getDefaultValue: () => DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  numberOfColumnsSlider: {
    type: StyleParamType.Number,
    key: 'numberOfColumnsSlider',
    getDefaultValue: () => DESK_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  },
  numberOfColumnsSliderHashtag: {
    type: StyleParamType.Number,
    key: 'numberOfColumnsSliderHashtag',
    getDefaultValue: () => DESK_SLIDER_DEFAULT_COUNT_ITEM_IN_ROW,
  },
  spacingSlider: {
    type: StyleParamType.Number,
    key: 'spacingSlider',
    getDefaultValue: () => DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  spacingItemsSliderHashtag: {
    type: StyleParamType.Number,
    key: 'spacingItemsSliderHashtag',
    getDefaultValue: () => DESK_DEFAULT_SPACE_BETWEEN_ITEMS,
  },
  showMoreCornerRadius: {
    type: StyleParamType.Number,
    key: 'showMoreCornerRadius',
    getDefaultValue: () => 0,
  },
  profilePictureSize: {
    type: StyleParamType.Number,
    key: 'profilePictureSize',
    getDefaultValue: () => DEFAULT_AVATAR_SIZE_DESKTOP,
  },
  profilePicturePaddingVer: {
    type: StyleParamType.Number,
    key: 'profilePicturePaddingVer',
    getDefaultValue: () => DEFAULT_AVATAR_PADDING_TOP_BOTTOM,
  },
  profilePicturePaddingHor: {
    type: StyleParamType.Number,
    key: 'profilePicturePaddingHor',
    getDefaultValue: () => DEFAULT_AVATAR_PADDING_LEFT_RIGHT,
  },
  displayOnHover: {
    type: StyleParamType.Number,
    key: 'displayOnHover',
    getDefaultValue: () => DISPLAY_ON_HOVER.CAPTIONS,
  },
  collagePostSizeHashtag: {
    type: StyleParamType.Number,
    key: 'collagePostSizeHashtag',
    getDefaultValue: () => COLLAGE_POST_SIZE.LARGE,
  },
  collagePostSize: {
    type: StyleParamType.Number,
    key: 'collagePostSize',
    getDefaultValue: () => COLLAGE_POST_SIZE.LARGE,
  },
  showMoreBorderGrid: {
    type: StyleParamType.Number,
    key: 'showMoreBorderGrid',
    getDefaultValue: () => 1,
  },
  itemBorderWidth: {
    type: StyleParamType.Number,
    key: 'itemBorderWidth',
    getDefaultValue: () => 0,
  },
  hashtagBorderWidth: {
    type: StyleParamType.Number,
    key: 'hashtagBorderWidth',
    getDefaultValue: () => 0,
  },
  [PROFILE_LAYOUT_POSITIN]: {
    type: StyleParamType.Number,
    key: PROFILE_LAYOUT_POSITIN,
    getDefaultValue: () => 0,
  },
  [FEED_LAYOUT_POSITIN]: {
    type: StyleParamType.Number,
    key: FEED_LAYOUT_POSITIN,
    getDefaultValue: () => 1,
  },
  [HASHTAG_LAYOUT_POSITIN]: {
    type: StyleParamType.Number,
    key: HASHTAG_LAYOUT_POSITIN,
    getDefaultValue: () => 2,
  },
  overlayEffect: {
    type: StyleParamType.Number,
    key: 'overlayEffect',
    getDefaultValue: () => OVERLAY_EFFECTS.FADE_IN,
  },
  imageHoverEffect: {
    type: StyleParamType.Number,
    key: 'imageHoverEffect',
    getDefaultValue: () => IMAGE_HOVER_EFFECTS.NO_EFFECTS,
  },
  sliderArrowsPadding: {
    type: StyleParamType.Number,
    key: 'sliderArrowsPadding',
    getDefaultValue: () => SLIDER_ARROW_SETTINGS.PADDING,
  },
  sliderArrowsPosition: {
    type: StyleParamType.Number,
    key: 'sliderArrowsPosition',
    getDefaultValue: () => SLIDER_ARROW_SETTINGS.POSITION.IN,
  },
  sliderArrowsSize: {
    type: StyleParamType.Number,
    key: 'sliderArrowsSize',
    getDefaultValue: () => SLIDER_ARROW_SETTINGS.SIZE,
  },
  /// //////////////////////
  // COLORS
  /// //////////////////////
  galleryHoverFillColor: {
    type: StyleParamType.Color,
    key: 'galleryHoverFillColor',
    getDefaultValue: wixColorParam('color-5', 0.6),
  },
  galleryHoverTextColor: {
    type: StyleParamType.Color,
    name: 'galleryHoverTextColor',
    getDefaultValue: wixColorParam('color-1'),
  },
  hoverHashtagColor: {
    type: StyleParamType.Color,
    key: 'hoverHashtagColor',
    getDefaultValue: wixColorParam('color-1', 0.5),
  },
  headerTitleColor: {
    type: StyleParamType.Color,
    name: 'headerTitleColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  headerCountersColor: {
    type: StyleParamType.Color,
    name: 'headerCountersColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  headerBioColor: {
    type: StyleParamType.Color,
    name: 'headerBioColor',
    getDefaultValue: wixColorParam('color-4'),
  },
  headerFullNameColor: {
    type: StyleParamType.Color,
    name: 'headerFullNameColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  headerLinksColor: {
    type: StyleParamType.Color,
    name: 'headerLinksColor',
    getDefaultValue: wixColorParam('color-8'),
  },
  hashtagsTextColor: {
    type: StyleParamType.Color,
    name: 'hashtagsTextColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  showMoreBackgroundGrid: {
    type: StyleParamType.Color,
    name: 'showMoreBackgroundGrid',
    getDefaultValue: wixColorParam('color-1'),
  },
  buttonsBgColorHover: {
    type: StyleParamType.Color,
    name: 'buttonsBgColorHover',
    getDefaultValue: wixColorParam('color-1', 0.7),
  },
  showMoreColorGrid: {
    type: StyleParamType.Color,
    key: 'showMoreColorGrid',
    getDefaultValue: wixColorParam('color-5'),
  },
  buttonBorderColor: {
    type: StyleParamType.Color,
    key: 'buttonBorderColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  buttonBorderColorHover: {
    type: StyleParamType.Color,
    key: 'buttonBorderColorHover',
    getDefaultValue: wixColorParam('color-5', 0.7),
  },
  buttonTextAndIconsColorHover: {
    type: StyleParamType.Color,
    key: 'buttonTextAndIconsColorHover',
    getDefaultValue: wixColorParam('color-5', 0.7),
  },
  itemBorderColor: {
    type: StyleParamType.Color,
    key: 'itemBorderColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  hashtagBorderColor: {
    type: StyleParamType.Color,
    key: 'hashtagBorderColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  appBgColor: {
    type: StyleParamType.Color,
    key: 'appBgColor',
    getDefaultValue: wixColorParam('color-1'),
  },
  headerBgColor: {
    type: StyleParamType.Color,
    key: 'headerBgColor',
    getDefaultValue: wixColorParam('color-1'),
  },
  feedBgColor: {
    type: StyleParamType.Color,
    key: 'feedBgColor',
    getDefaultValue: wixColorParam('color-1'),
  },
  hashtagsBgColor: {
    type: StyleParamType.Color,
    key: 'hashtagsBgColor',
    getDefaultValue: wixColorParam('color-1'),
  },
  sliderArrowsColor: {
    type: StyleParamType.Color,
    key: 'sliderArrowsColor',
    getDefaultValue: wixColorParam('color-5'),
  },
  /// //////////////////////
  // FONTS
  /// //////////////////////
  userNameFont: {
    type: StyleParamType.Font,
    key: 'userNameFont',
    getDefaultValue: wixFontParam('Body-M', {
      size: 24,
    }),
  },
  countersFont: {
    type: StyleParamType.Font,
    key: 'countersFont',
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
  },
  bioFont: {
    type: StyleParamType.Font,
    key: 'bioFont',
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
  },
  hashtagsFont: {
    type: StyleParamType.Font,
    key: 'hashtagsFont',
    getDefaultValue: wixFontParam('Body-M', {
      size: 24,
    }),
  },
  showMoreFontGrid: {
    type: StyleParamType.Font,
    key: 'showMoreFontGrid',
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
  },
  galleryHoverFont: {
    type: StyleParamType.Font,
    key: 'galleryHoverFont',
    getDefaultValue: wixFontParam('Body-M', {
      size: 16,
    }),
  },
};

export default instagramStyleParams;
